import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EmojiContextProvider } from './EmojiContextProvider';

/**
 * Legacy Context Priority Passthrough ...
 * If component finds legacy context, then use it, otherwise use the passed through context
 */
export default class LegacyEmojiContextProvider extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      prioritisedContextValue: context.emoji ? context : this.props.emojiContextValue
    };
  }

  render() {
    if (this.state.prioritisedContextValue) {
      return /*#__PURE__*/React.createElement(EmojiContextProvider, {
        emojiContextValue: this.state.prioritisedContextValue
      }, this.props.children);
    }

    return this.props.children;
  }

}

_defineProperty(LegacyEmojiContextProvider, "contextTypes", {
  emoji: PropTypes.object
});